import store from '@/store'
import MODULE_TYPES from '@/store/modules/types'

export async function hasAccess({ next }) {
    if (await store.state[MODULE_TYPES.ADMIN].hasBaseAccess) return next()
    return next({ name: 'Forbidden' })
}
